var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObSpecialNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBSpecialNote_svg__clip0_8255_40908)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.333c.368 0 .667.299.667.667v2.667a.667.667 0 11-1.334 0V8c0-.368.299-.667.667-.667zM8 6.333a.833.833 0 100-1.666.833.833 0 000 1.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 8a6.667 6.667 0 1113.334 0A6.667 6.667 0 011.333 8zM8 2.667a5.333 5.333 0 100 10.666A5.333 5.333 0 008 2.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBSpecialNote_svg__clip0_8255_40908"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 1.333)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgObSpecialNote;